import { useSyncExternalStore } from 'react';

const ADMIN_COMPACT_MAX_WIDTH = 959;

function getMediaQuery() {
  return window.matchMedia(`(max-width: ${ADMIN_COMPACT_MAX_WIDTH}px)`);
}

function subscribe(onStoreChange: () => void) {
  const mediaQuery = getMediaQuery();
  mediaQuery.addEventListener('change', onStoreChange);
  window.addEventListener('resize', onStoreChange);

  return () => {
    mediaQuery.removeEventListener('change', onStoreChange);
    window.removeEventListener('resize', onStoreChange);
  };
}

function getSnapshot() {
  return getMediaQuery().matches;
}

function getServerSnapshot() {
  return false;
}

export default function useIsAdminCompact() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
